import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-arrow-right-16",
  "use": "icon-common-arrow-right-16-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" fill=\"none\" id=\"icon-common-arrow-right-16\">\n  <path d=\"M5.74902 4.04706L10.249 8.54706L5.74902 13.0471\" stroke=\"#1D1D1D\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol